import { useEffect } from 'react';

import { hide, show } from '@atlassian/customer-service-management-widget-sdk-react/commands';

import { initCSM } from '../../utils/initCSM';

type AiCornerAgentProps = {
	/** Suppresses the SDK launcher while another assistant is displayed. */
	isSuppressed?: boolean;
	locale?: string;
	site?: string;
	siteId?: string;
	widgetId: string;
};

/**
 * Initialises the CSM widget when mounted
 */
export const AiCornerAgent = ({
	locale,
	site,
	siteId,
	widgetId,
	isSuppressed = false,
}: AiCornerAgentProps) => {
	useEffect(() => {
		if (!isSuppressed) {
			initCSM({ locale, site, siteId, widgetId });
		}
	}, [locale, site, siteId, widgetId, isSuppressed]);

	useEffect(() => {
		if (!isSuppressed || !('CSM' in window) || !window.CSM) {
			return;
		}

		// The SDK owns the launcher outside React and queues commands while loading.
		hide();
		return () => {
			show();
		};
	}, [isSuppressed]);

	return null;
};
